import React from "react";
import "./styles/about_us.css";
import founderImage from "../images/founder.jpg";

const AboutUs = () => {
  return (
    <div className="about-container">
      <section className="founder-section">
        <div className="founder-image-container">
          <img src={founderImage} alt="Founder" className="founder-image" />
        </div>
        <div className="founder-description">
          <h2>
            Meet Our Founder
            <br />
          </h2>
          <p>
            📍 Ramchandra Hanspal (Ram) <br />
            👑 Founder – New Ganesh Bakers <br />
            📅 Since 1989 – A Legacy of Taste & Trust
          </p>

          <p>
            With hard work, passion, and an unbreakable will, Ram Hanspal laid
            the foundation of New Ganesh Bakers in 1989. What started as a
            humble bakery is now a name synonymous with quality, tradition, and
            unbeatable taste. His journey is one of sweat, determination, and an
            unwavering commitment to bringing the best bakery products to every
            household.
          </p>
          <p>
            New Ganesh Bakers started as a small bakery with a vision to provide
            fresh, high-quality baked goods to the people of Indore. Over the
            years, our commitment to excellence has helped us grow into a
            household name. We take pride in blending traditional recipes with
            modern baking techniques to create a wide range of products that
            cater to every palate
          </p>
        </div>
      </section>
    </div>
  );
};
export default AboutUs;
